import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, inject, OnDestroy } from '@angular/core';
import { BaseModule } from '../../shared/base.module';

@Component({
  selector: 'app-chat-events',
  templateUrl: './chat-events.component.html',
  styleUrls: ['./chat-events.component.scss'],
  imports: [
    BaseModule,
  ]
})
export class ChatEventsComponent implements OnInit, OnDestroy {
  @Input() events: any[] = [];
  @Output() endEvent = new EventEmitter<any>();

  localTime: Date = new Date();
  interval: any;
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.interval = setInterval(() => {
      this.cdr.markForCheck();
      this.localTime = new Date();
      
    }, 1000);
  }
  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    } 
  }

  isOngoing(event: any): boolean {
    const now = this.localTime.getTime();
    const start = new Date(event.start_date).getTime();
    const end = start + event.duration * 60 * 60 * 1000;
    return now >= start && now <= end;
  }

  isEnded(event: any): boolean {
    const now = this.localTime.getTime();
    const start = new Date(event.start_date).getTime();
    const end = start + event.duration * 60 * 60 * 1000;
    return now > end;
  }

  timeRemaining(event: any): string {
    const now = this.localTime.getTime();
    const start = new Date(event.start_date).getTime();
    const end = start + event.duration * 60 * 60 * 1000;

    if (now < start) {
      const diff = start - now;
      return this.formatTime(diff);
    } else if (now <= end) {
      const diff = end - now;
      return this.formatTime(diff);
    } else {
      return 'Finalizado';
    }
  }

  timeElapsed(event: any): string {
    const now = this.localTime.getTime();
    const start = new Date(event.start_date).getTime();

    if (now >= start) {
      const diff = now - start;
      return this.formatTime(diff);
    } else {
      return 'No iniciado';
    }
  }

  formatTime(milliseconds: number): string {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
    const seconds = (totalSeconds % 60).toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }

  end(event: any): void {
    this.endEvent.emit(event);
  }
}